


<div class="dashboard">
  <!-- Modern Header -->
  <header class="dashboard-header">
    <div class="header-content">
      <h2>Conversation Analytics</h2>
      <div class="tokens-card">
        <mat-card class="tokens-mat-card">
          <mat-card-content>
            <div class="tokens-label">Unique Customers</div>
            <div class="tokens-value">{{ uniqueNumbers | number }}</div>
            <!-- <div class="tokens-value">{{ billingData?.currentAvailable | number }}</div> -->
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </header>

  <!-- Tabs with filters inside each tab -->
  <mat-tab-group (selectedTabChange)="onTabChange($event)" class="analytics-tabs">

    <!-- Conversations Tab -->
    <mat-tab label="Conversations">
      <section class="tab-content">
        <div class="filters">
          <mat-form-field appearance="outline">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="picker1" [(ngModel)]="startDate" />
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="picker2" [(ngModel)]="endDate" />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
          </mat-form-field>

          <button mat-raised-button color="primary" (click)="loadDailyStats()">
            <mat-icon>timeline</mat-icon>
            Load Stats
          </button>
        </div>

        <!-- Charts & Table for this tab -->
        <div class="content-area">
          <!-- Loading -->
          <div *ngIf="loading" class="loading">
            <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
            <p>Loading data...</p>
          </div>

          <!-- Charts -->
          <section class="charts">
            <mat-card class="chart-card" *ngIf="lineChartData.labels?.length">
              <mat-card-header>
                <mat-card-title>Conversations per Day</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <canvas baseChart
                  [data]="lineChartData"
                  [type]="'line'"
                  [options]="lineChartOptions"
                  (chartClick)="onChartClick($event)">
                </canvas>
              </mat-card-content>
            </mat-card>

             <mat-card class="chart-card" *ngIf="barChartData.labels?.length">
              <mat-card-header>
                <mat-card-title>Conversation Activity ({{ conversationId }})</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <canvas baseChart
                  [data]="barChartData"
                  [type]="'bar'"
                  [options]="barChartOptions"
                  (chartClick)="onBarChartClick($event)">
                </canvas>
              </mat-card-content>
            </mat-card>
          </section>

          <!-- Table -->
          <section class="conversation-table" *ngIf="conversationsDataSource.data.length > 0">
            <h3>Conversations for {{ selectedDay }}</h3>
            <table mat-table [dataSource]="conversationsDataSource" class="styled-table">
              <ng-container matColumnDef="conversation_id">
                <th mat-header-cell *matHeaderCellDef>Conversation ID</th>
                <td mat-cell *matCellDef="let row">{{ row.conversation_id }}</td>
              </ng-container>

              <ng-container matColumnDef="total_message_count">
                <th mat-header-cell *matHeaderCellDef>Total Messages</th>
                <td mat-cell *matCellDef="let row">{{ row.total_message_count }}</td>
              </ng-container>

              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let row">
                  <button mat-stroked-button color="primary" (click)="goToConversation(row.conversation_id)">
                    View
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </section>

          <div *ngIf="!conversationsDataSource.data.length && !loading && selectedDay" class="no-results">
            No conversations found for {{ selectedDay }}.
          </div>
        </div>
      </section>
    </mat-tab>

    <!-- Customer Search Tab -->
    <mat-tab label="Customer Search">
      <section class="tab-content">
        <div class="filters">
          <mat-form-field appearance="outline">
            <mat-label>Start Date</mat-label>
            <input matInput [matDatepicker]="picker3" [(ngModel)]="startDate" />
            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
            <mat-datepicker #picker3></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="picker4" [(ngModel)]="endDate" />
            <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
            <mat-datepicker #picker4></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="phone-input">
            <mat-label>Phone Number (234xxxxxxxxxx)</mat-label>
            <input matInput [(ngModel)]="conversationId" />
          </mat-form-field>

          <button mat-raised-button color="accent" [disabled]="!conversationId" (click)="loadConversationActivity()">
            <mat-icon>search</mat-icon>
            Search Activity
          </button>
        </div>

        <div class="content-area">
          <div *ngIf="loading" class="loading">
            <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
            <p>Loading data...</p>
          </div>

          <section class="charts">
            <mat-card class="chart-card" *ngIf="barChartData.labels?.length">
              <mat-card-header>
                <mat-card-title>Conversation Activity ({{ conversationId }})</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <canvas baseChart
                  [data]="barChartData"
                  [type]="'bar'"
                  [options]="barChartOptions"
                  (chartClick)="onBarChartClick($event)">
                </canvas>
              </mat-card-content>
            </mat-card>
          </section>
        </div>
      </section>
    </mat-tab>

  </mat-tab-group>

  <!-- <app-category-distribution></app-category-distribution>
  <app-outcome-distribution></app-outcome-distribution>
  <app-outcome-rate></app-outcome-rate>
  <app-engagement-frequency></app-engagement-frequency>
  <app-cross-tab></app-cross-tab>
  <app-conversation-explorer></app-conversation-explorer> -->
  <!-- <app-conversation-details></app-conversation-details> -->
</div>